import React from "react";
import Navbar from "../Components/Navbar/Navbar";

const Android = () => {
  return (
    <div>
      <Navbar />
      <div>Android</div>
    </div>
  );
};

export default Android;
